// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"Z9-z"};